/**
 * Check if the user is connected to the internet
 * Uses the browser's built-in navigator.onLine property
 * Returns true if the user is connected, false otherwise
*/

export function checkNetworkStatus() {
    return navigator.onLine
}